<template>
  <SearchContainer @reset="resetFilters" @search="search">
    <template slot="default">
      <div class="row">
        <div class="col-12 col-sm-4 mb-3">
          <Input
            type="text"
            :label="$t('sections.guarantees.search.entityName')"
            :field="query.entityName"
            @input="(e) => onInput('entityName', e)"
          />
        </div>
        <div class="col-12 col-sm-4 mb-3">
          <Input
            type="dropdown"
            :label="$t('sections.guarantees.search.entityType')"
            :field="query.entityType"
            :items="$t('sections.guarantees.search.entityTypeOptions')"
            @input="(e) => onInput('entityType', e)"
            button
            @onClick="search"
          />
        </div>
      </div>
    </template>
  </SearchContainer>
</template>
<script>
import SearchContainer from '@/components/sections/common/SearchContainer.vue';
import Input from '@/components/ui/Input.vue';

export default {
  name: 'GuaranteesSearchOptions',
  components: {
    SearchContainer,
    Input,
  },
  data() {
    return {
      query: {
        entityName: '',
        entityType: '',
      },
    };
  },
  computed: {
    validSearch() {
      // TODO check required fields
      return true;
    },
  },
  methods: {
    onInput(field, value) {
      this.query[field] = value;
    },
    search() {
      this.$emit('onSearch', this.query);
    },
    resetFilters() {
      this.query = {
        entityName: '',
        entityType: '',
      };

      this.$emit('onSearch', this.query);
    },
  },
};
</script>
<style lang="scss" scoped></style>
